import Vue from "vue";
import deviceTypes from "@/device-types";

// import _ from "lodash";

const scrStatuses = {
	1: "Draft",
	2: "Submitted",
	3: "Reviewed",
	4: "Deleted",
	5: "Complete"
};

const initialState = {
	title: "",
	scrModify: false,
	deviceTypeId: 0,
	scrStatusId: 1,
	mixonHillApproved: false,
	clientApproved: false,
	clients: [],
	credentialTypesList: [],
	intersections: [],
	ipAddressTypes: [],
	locationTypes: [],
	macAddressTypes: [],
	models: [],
	privilegeTypes: [],
	authTypes: [],
	tenants: [],
	devicetenants: [],
	testLabs: [],
	network: null,
	VUs: [],
	people: [],
	errors: {},
	viewModel: {},
	appTypes: [],
	movements: [],
	totalStations: [],
	totalStationName: "",
	deviceId: 0,
	relationship: "",
	deviceLocation: { lat: 0, lon: 0 },
	testRunning: false,
	labTests: [],
	isTotalStationSCR: false,
	canEdit: false,
	readOnly: false,
	scrStatus: "Draft",
	isTotalStationReadOnly: false,
	NetworkList: [],
	HistoryList: [],
	LatestChanges: []
};

export default {
	namespaced: true,

	state: {},

	mutations: {
		updateState(state, { id }) {
			Vue.set(state, id, Object.assign({}, initialState));
		},
		removeState: (state, { id, payload }) => Vue.set(state, id, payload),
		updateDeviceTypeId: (state, { id, deviceTypeId, isTotalStationSCR }) => {
			state[id].deviceTypeId = deviceTypeId;
			state[id].isTotalStationSCR = isTotalStationSCR;
			state[id].deviceTypeName = isTotalStationSCR
				? "TS"
				: deviceTypes[deviceTypeId].shortName;
		},
		updateClients: (state, { id, clients }) => (state[id].clients = clients),
		updatecredentialTypesList: (state, { id, credentialTypesList }) =>
			(state[id].credentialTypesList = credentialTypesList),
		updateIntersections: (state, { id, intersections }) =>
			(state[id].intersections = intersections),
		updateIpAddressTypes: (state, { id, ipAddressTypes }) =>
			(state[id].ipAddressTypes = ipAddressTypes),
		updateLocationTypes: (state, { id, locationTypes }) =>
			(state[id].locationTypes = locationTypes),
		updateMacAddressTypes: (state, { id, macAddressTypes }) =>
			(state[id].macAddressTypes = macAddressTypes),
		updateModels: (state, { id, models }) => (state[id].models = models),
		updatePrivilegeTypes: (state, { id, privilegeTypes }) =>
			(state[id].privilegeTypes = privilegeTypes),
		updateAuthTypes: (state, { id, authTypes }) =>
			(state[id].authTypes = authTypes),
		updateTenants: (state, { id, tenants }) => (state[id].tenants = tenants),
		updateDeviceTenants: (state, { id, devicetenants }) =>
			(state[id].devicetenants = devicetenants),
		updateTestLabs: (state, { id, testLabs }) =>
			(state[id].testLabs = testLabs),
		updateNetwork: (state, { id, network }) => (state[id].network = network),
		updateVUs: (state, { id, VUs }) => (state[id].VUs = VUs),
		addError: (state, { id, prop, error }) =>
			Vue.set(state[id].errors, prop, error),
		clearErrors: (state, { id }) => {
			state[id].errors = {};
		},
		updateViewModel: (state, { id, viewModel }) => {
			state[id].viewModel = viewModel;
		},
		updateDeviceScrId: (state, { id, deviceScrId }) => {
			state[id].viewModel.deviceScrId = deviceScrId;
		},
		updateProjectNumber: (state, { id, projectNumber }) =>
			(state[id].viewModel.projectNumber = projectNumber),
		updateSaveInfo: (state, { id, saveInfo }) => {
			state[id].saveInfo = saveInfo;
		},
		updateTenantId: (state, { id, tenantId }) =>
			(state[id].viewModel.tenantId = tenantId),
		updateClientNetworkId: (state, { id, clientnetworkId }) =>
			(state[id].viewModel.clientnetworkId = clientnetworkId),
		updateRequestDate: (state, { id, requestDate }) =>
			(state[id].viewModel.requestDate = requestDate),
		updateManufacturerId: (state, { id, manufacturerId }) =>
			(state[id].viewModel.manufacturerId = manufacturerId),
		updateModelId: (state, { id, modelId }) =>
			(state[id].viewModel.modelId = modelId),
		updateInfrastructureOwnerId: (state, { id, infrastructureOwnerId }) =>
			(state[id].viewModel.infrastructureOwnerId = infrastructureOwnerId),
		updateInfrastructureOperatorId: (
			state,
			{ id, infrastructureOperatorId }
		) => {
			state[id].viewModel.infrastructureOperatorId = infrastructureOperatorId;
		},
		updateDeviceRoles: (state, { id }) => {
			state[id].scrApproveRole = state[id].deviceTypeId
				? "SCR" + state[id].deviceTypeName + "approve"
				: "NONE";
			state[id].scrSysApproveRole = state[id].deviceTypeId
				? "SCR" + state[id].deviceTypeName + "sysapprove"
				: "NONE";
			state[id].scrEditRole = state[id].deviceTypeId
				? "SCR" + state[id].deviceTypeName + "edit"
				: "NONE";
			state[id].scrLabTestRole = state[id].deviceTypeId
				? state[id].deviceTypeName + "labtest"
				: "NONE";
		},
		updateSCRViewDetails: (
			state,
			{ id, isReadOnly, canEditSCR, isTSReadOnly, hasTestViewRole, hasTestRole }
		) => {
			state[id].canEdit = canEditSCR;
			state[id].readOnly = isReadOnly;
			state[id].isTotalStationReadOnly = isTSReadOnly;
			state[id].hasViewTestRole = hasTestViewRole;
			state[id].hasTestRole = hasTestRole;
		},

		updateDeviceName: (state, { id, deviceName }) =>
			(state[id].viewModel.deviceName = deviceName),
		updateLocationTypeId: (state, { id, locationTypeId }) =>
			(state[id].viewModel.locationTypeId = locationTypeId),
		updateAreaDescription: (state, { id, areaDescription }) =>
			(state[id].viewModel.areaDescription = areaDescription),
		updateLatitude: (state, { id, latitude }) =>
			(state[id].viewModel.latitude = latitude),
		updateLongitude: (state, { id, longitude }) =>
			(state[id].viewModel.longitude = longitude),
		updateElevation: (state, { id, elevation }) =>
			(state[id].viewModel.elevation = elevation),
		updateAdditionalDetails: (state, { id, additionalDetails }) =>
			(state[id].viewModel.additionalDetails = additionalDetails),
		addIpAddress: (state, { id, ipAddress }) =>
			Vue.set(
				state[id].viewModel,
				"ipAddresses",
				state[id].viewModel.ipAddresses.concat([ipAddress])
			),
		removeIpAddress: (state, { id, index }) =>
			Vue.set(
				state[id].viewModel,
				"ipAddresses",
				state[id].viewModel.ipAddresses.filter((_v, i) => i !== index)
			),
		updateIpAddressToNull: (state, { id, ipAddresses }) =>
			(state[id].viewModel.ipAddresses = ipAddresses),
		addMacAddress: (state, { id, macAddress }) =>
			Vue.set(
				state[id].viewModel,
				"macAddresses",
				state[id].viewModel.macAddresses.concat([macAddress])
			),
		removeMacAddress: (state, { id, index }) =>
			Vue.set(
				state[id].viewModel,
				"macAddresses",
				state[id].viewModel.macAddresses.filter((_v, i) => i !== index)
			),
		addCredential: (state, { id, credential }) =>
			Vue.set(
				state[id].viewModel,
				"credentials",
				state[id].viewModel.credentials.concat([credential])
			),
		removeCredential: (state, { id, index }) =>
			Vue.set(
				state[id].viewModel,
				"credentials",
				state[id].viewModel.credentials.filter((_v, i) => i !== index)
			),
		updateCredential: (state, { id, credential, index }) =>
			Vue.set(state[id].viewModel.credentials, index, credential),
		updateTitle: (state, { id, title }) => {
			state[id].title = title;
		},
		updateScrModify: (state, { id, scrModify }) =>
			(state[id].scrModify = scrModify),
		updateScrStatusId: (state, { id, scrStatusId }) => {
			state[id].scrStatusId = scrStatusId;
			state[id].scrStatus = scrStatuses[scrStatusId];
		},
		updateMixonHillApproved: (state, { id, mixonHillApproved }) =>
			(state[id].mixonHillApproved = mixonHillApproved),
		updateClientApproved: (state, { id, clientApproved }) =>
			(state[id].clientApproved = clientApproved),
		updatePeople: (state, { id, people }) => (state[id].people = people),
		updateInstallationSupportPersonId: (
			state,
			{ id, installationSupportPersonId }
		) =>
			(state[
				id
			].viewModel.installationSupportPersonId = installationSupportPersonId),
		updateInstallationSupportFirstName: (
			state,
			{ id, installationSupportFirstName }
		) =>
			(state[
				id
			].viewModel.installationSupportFirstName = installationSupportFirstName),
		updateInstallationSupportLastName: (
			state,
			{ id, installationSupportLastName }
		) =>
			(state[
				id
			].viewModel.installationSupportLastName = installationSupportLastName),
		updateInstallationSupportPhone: (state, { id, installationSupportPhone }) =>
			(state[id].viewModel.installationSupportPhone = installationSupportPhone),
		updateInstallationSupportEmail: (state, { id, installationSupportEmail }) =>
			(state[id].viewModel.installationSupportEmail = installationSupportEmail),
		updateMaintenanceSupportPersonId: (
			state,
			{ id, maintenanceSupportPersonId }
		) =>
			(state[
				id
			].viewModel.maintenanceSupportPersonId = maintenanceSupportPersonId),
		updateMaintenanceSupportFirstName: (
			state,
			{ id, maintenanceSupportFirstName }
		) =>
			(state[
				id
			].viewModel.maintenanceSupportFirstName = maintenanceSupportFirstName),
		updateMaintenanceSupportLastName: (
			state,
			{ id, maintenanceSupportLastName }
		) =>
			(state[
				id
			].viewModel.maintenanceSupportLastName = maintenanceSupportLastName),
		updateMaintenanceSupportPhone: (state, { id, maintenanceSupportPhone }) =>
			(state[id].viewModel.maintenanceSupportPhone = maintenanceSupportPhone),
		updateMaintenanceSupportEmail: (state, { id, maintenanceSupportEmail }) =>
			(state[id].viewModel.maintenanceSupportEmail = maintenanceSupportEmail),
		updateSerialNumber: (state, { id, serialNumber }) =>
			(state[id].viewModel.serialNumber = serialNumber),
		updateFirmwareVersion: (state, { id, firmwareVersion }) =>
			(state[id].viewModel.firmwareVersion = firmwareVersion),
		updateAppTypes: (state, { id, appTypes }) => {
			state[id].appTypes = appTypes;
		},
		updateApproachDetails: (state, { id, approachDetails }) =>
			Vue.set(state[id].viewModel, "approachDetails", approachDetails),
		addApproachDetails: (state, { id, approachDetails }) =>
			Vue.set(
				state[id].viewModel,
				"approachDetails",
				state[id].viewModel.approachDetails.concat([approachDetails])
			),
		removeApproachDetails: (state, { id, laneid }) => {
			Vue.set(
				state[id].viewModel,
				"approachDetails",
				state[id].viewModel.approachDetails.filter(a => a.laneid !== laneid)
			);
		},
		updateApplications: (state, { id, application }) =>
			Vue.set(state[id].viewModel, "applications", application),
		addApplication: (state, { id, application }) => {
			Vue.set(
				state[id].viewModel,
				"applications",
				state[id].viewModel.applications.concat([application])
			);
		},
		removeApplication: (state, { id, appType }) =>
			Vue.set(
				state[id].viewModel,
				"applications",
				state[id].viewModel.applications.filter(a => a.appType !== appType)
			),
		updateIntersectionId: (state, { id, intersectionId }) =>
			Vue.set(state[id].viewModel, "intersectionId", intersectionId),
		updateMovements: (state, { id, movements }) =>
			Vue.set(state[id], "movements", movements),
		updateIntersectionMovementPhases: (
			state,
			{ id, intersectionMovementPhases }
		) =>
			Vue.set(
				state[id].viewModel,
				"intersectionMovementPhases",
				intersectionMovementPhases
			),
		updateIntersectionMovementPhaseNumber: (
			state,
			{ id, index, phaseNumber }
		) =>
			Vue.set(
				state[id].viewModel.intersectionMovementPhases[index],
				"phaseNumber",
				phaseNumber
			),
		updateTotalStations: (state, { id, totalStations }) =>
			Vue.set(state[id], "totalStations", totalStations),
		updateTotalStationName: (state, { id, totalStationName }) => {
			state[id].viewModel.totalStationName = totalStationName;
		},
		updateRejectReason: (state, { id, rejectReason }) =>
			(state[id].viewModel.rejectReason = rejectReason),
		updateRelationship: (state, { id, relationship }) =>
			(state[id].relationship = relationship),
		updateTestMode: (state, { id, inTestMode }) => {
			state[id].viewModel.inTestMode = inTestMode;
		},
		updateTestLabId: (state, { id, testLabId }) =>
			(state[id].viewModel.testLabId = testLabId),
		updateNetworkId: (state, { id, networkId }) =>
			(state[id].viewModel.networkId = networkId),
		updateTestIP: (state, { id, testIP }) =>
			(state[id].viewModel.testIP = testIP),
		updateLabTests: (state, { id, labTests }) =>
			(state[id].labTests = labTests),
		updateLabTestId: (state, { id, labTestId }) =>
			(state[id].viewModel.labTestId = labTestId),
		updateTestCompletion: (state, { id, testCompletion }) =>
			(state[id].viewModel.testCompletion = testCompletion),
		updateTestStatus: (state, { id, testStatus }) =>
			(state[id].viewModel.testStatus = testStatus),
		updateTestResults: (state, { id, testResults }) =>
			(state[id].viewModel.testResults = testResults),
		updateVuId: (state, { id, vuId }) => (state[id].viewModel.vuId = vuId),
		updateESSInterfaceList: (state, { id, ESSInterfaceList }) => {
			Vue.set(state[id].viewModel, "ESSInterfaceList", ESSInterfaceList);
		},
		updateNetworkList: (state, { id, NetworkList }) => {
			Vue.set(state[id].viewModel, "NetworkList", NetworkList);
		},
		updateStationCategory: (state, { id, StationCategory }) => {
			state[id].StationCategory = StationCategory;
		},
		updateStationCategoryValue: (state, { id, StationCategoryValue }) => {
			Vue.set(
				state[id].viewModel,
				"StationCategoryValue",
				StationCategoryValue
			);
		},
		updateStationTypes: (state, { id, StationTypes }) => {
			state[id].StationTypes = StationTypes;
		},
		updateStationTypeValue: (state, { id, StationTypeValue }) => {
			Vue.set(state[id].viewModel, "StationTypeValue", StationTypeValue);
		},
		updateSensorDataRequest: (state, { id, SensorDataRequest }) => {
			Vue.set(state[id].viewModel, "SensorDataRequest", SensorDataRequest);
		},
		updateHttpFlag: (state, { id, HttpFlag }) => {
			state[id].HttpFlag = HttpFlag;
		},
		updateRegionDistrictList: (state, { id, RegionDistrictList }) => {
			Vue.set(state[id], "RegionDistrictList", RegionDistrictList);
		},
		updateRegionDistrict: (state, { id, RegionDistrict }) =>
			(state[id].viewModel.RegionDistrict = RegionDistrict),
		updatePortTypeLists: (state, { id, PortTypeLists }) => {
			Vue.set(state[id], "PortTypeLists", PortTypeLists);
		},
		updatePortTypes: (state, { id, PortTypes }) =>
			(state[id].viewModel.PortTypes = PortTypes),
		updateHighway: (state, { id, Highway }) =>
			(state[id].viewModel.Highway = Highway),
		updateMilePost: (state, { id, MilePost }) =>
			(state[id].viewModel.MilePost = MilePost),
		updateSiteAddress: (state, { id, SiteAddress }) =>
			(state[id].viewModel.SiteAddress = SiteAddress),
		updateDirection: (state, { id, Direction }) =>
			(state[id].viewModel.Direction = Direction),
		updateDrivingAccess: (state, { id, DrivingAccess }) =>
			(state[id].viewModel.DrivingAccess = DrivingAccess),
		updatehttpEnabledChkBx: (state, { id, httpEnabledChkBx }) =>
			Vue.set(state[id].viewModel, "httpEnabledChkBx", httpEnabledChkBx),
		updateHttpFlagValue: (state, { id, HttpFlagValue }) =>
			Vue.set(state[id].viewModel, "HttpFlagValue", HttpFlagValue)
	},
	getters: {
		scrInfoByID(state) {
			return id => state[id];
		},
		hasErrors: (state, id) => !!Object.keys(state[id].errors).length,
		scrStatus: (state, id) => {
			return state[id].scrStatus;
		},
		title: (state, id) => state[id].title,
		scrModify: (state, id) => state[id].scrModify,
		testLabId: (state, id) =>
			state[id].viewModel.testLabId ? state[id].viewModel.testLabId : null,
		mixonHillApproved: (state, id) => state[id].mixonHillApproved,
		clientApproved: (state, id) => state[id].clientApproved,
		deviceTypeId: (state, id) => {
			return state[id].deviceTypeId;
		},
		deviceTypeName: (state, id) => {
			return state[id].deviceTypeName;
		},

		viewModel: (state, id) => {
			state[id].viewModel ? state[id].viewModel : null;
		},
		testIP: (state, id) =>
			state[id].viewModel.testIP ? state[id].viewModel.testIP : "",
		labTestId: (state, id) =>
			state[id].viewModel.labTestId ? state[id].viewModel.labTestId : "",
		serialNumber: (state, id) => state[id].viewModel.serialNumber,
		ipAddressTypes: (state, id) =>
			state[id].ipAddressTypes ? state[id].ipAddressTypes : null,
		macAddressTypes: (state, id) =>
			state[id].macAddressTypes ? state[id].macAddressTypes : null,
		tenants: (state, id) => (state[id].tenants ? state[id].tenants : null),
		devicetenants: (state, id) =>
			state[id].devicetenants ? state[id].devicetenants : null,
		testLabs: (state, id) => (state[id].testLabs ? state[id].testLabs : null),
		network: (state, id) => (state[id].network ? state[id].network : null),
		networkId: (state, id) =>
			state[id].viewModel.networkId ? state[id].viewModel.networkId : null,
		VUs: (state, id) => (state[id].VUs ? state[id].VUs : null),
		credentialTypesList: (state, id) =>
			state[id].credentialTypesList ? state[id].credentialTypesList : null,
		privilegeTypes: (state, id) =>
			state[id].privilegeTypes ? state[id].privilegeTypes : null,
		authTypes: (state, id) =>
			state[id].authTypes ? state[id].authTypes : null,
		totalStationOptions: (state, id) => state[id].totalStations,
		scrApproveRole: (state, id) => state[id].scrApproveRole,
		scrSysApproveRole: (state, id) => state[id].scrSysApproveRole,
		scrEditRole: (state, id) => state[id].scrEditRole,
		scrLabTestRole: (state, id) => state[id].scrLabTestRole,
		readonly: (state, id) => {
			return state[id].readonly;
		},
		canEdit: (state, id) => {
			return state[id].canEdit;
		},
		isTotalStationReadOnly: (state, id) => {
			return state[id].isTotalStationReadOnly;
		},

		isTotalStationSCR: (state, id) => {
			return state[id].isTotalStationSCR ? state[id].isTotalStationSCR : null;
		},
		hasTestRole: (state, id) => {
			return state[id].hasTestRole;
		},
		hasViewTestRole: (state, id) => {
			return state[id].hasViewTestRole;
		},
		totalStationName: (state, id) => state[id].viewModel.totalStationName,
		rejectReason: (state, id) =>
			state[id].viewModel ? state[id].viewModel.rejectReason : "",
		relationship: (state, id) => state[id].relationship,
		errors: (state, id) => state[id].errors,
		StationCategory: (state, id) =>
			state[id].StationCategory ? state[id].StationCategory : null,
		ESSInterfaceList: (state, id) => state[id].viewModel.ESSInterfaceList,
		TotalStationInfoList: (state, id) =>
			state[id].viewModel.TotalStationInfoList,
		NetworkList: (state, id) => state[id].viewModel.NetworkList,
		HistoryList: (state, id) => state[id].viewModel.HistoryList,
		LatestChanges: (state, id) => state[id].viewModel.LatestChanges,
		StationCategoryValue: (state, id) =>
			state[id].viewModel.StationCategoryValue,
		StationTypes: (state, id) =>
			state[id].StationTypes ? state[id].StationTypes : null,
		StationTypeValue: (state, id) => state[id].viewModel.StationTypeValue,
		RegionDistrictList: (state, id) =>
			state[id].RegionDistrictList ? state[id].RegionDistrictList : null,
		RegionDistrict: (state, id) => state[id].viewModel.RegionDistrict,
		PortTypeLists: (state, id) =>
			state[id].PortTypeLists ? state[id].PortTypeLists : null,
		PortTypes: (state, id) =>
			state[id].viewModel.PortTypes ? state[id].viewModel.PortTypes : null,
		CredentialType: (state, id) =>
			state[id].viewModel.CredentialType
				? state[id].viewModel.CredentialType
				: null,

		Highway: (state, id) => state[id].viewModel.Highway,
		MilePost: (state, id) => state[id].viewModel.MilePost,
		SiteAddress: (state, id) => state[id].viewModel.SiteAddress,
		Direction: (state, id) => state[id].viewModel.Direction,
		DrivingAccess: (state, id) => state[id].viewModel.DrivingAccess,
		HttpFlag: (state, id) => (state[id].HttpFlag ? state[id].HttpFlag : null),
		HttpFlagValue: (state, id) => state[id].viewModel.HttpFlagValue,
		httpEnabledChkBx: (state, id) => state[id].viewModel.httpEnabledChkBx,
		httpIsNewChkbx: (state, id) => state[id].viewModel.httpIsNewChkbx,
		SensorDataRequest: (state, id) =>
			state[id].SensorDataRequest ? state[id].SensorDataRequest : null,
		testRunning: (state, id) => state[id].testRunning,
		inTestMode: (state, id) => state[id].viewModel.inTestMode,
		labTests: (state, id) => (state[id].labTests ? state[id].labTests : null),
		locationTypeId: (state, id) => {
			state[id].viewModel.locationTypeId
				? state[id].viewModel.locationTypeId
				: "";
		},
		vuId: (state, id) => (state[id].viewModel ? state[id].viewModel.vuId : ""),
		deviceLocation: (state, id) => state[id].deviceLocation,
		approachDetails: (state, id) =>
			state[id].viewModel.approachDetails
				? state[id].viewModel.approachDetails
				: []
	},
	actions: {
		updateState: ({ commit }, { id }) => commit("updateState", { id }),
		removeState: ({ commit }, { id }) => commit("removeState", { id }),
		updateDeviceTypeId: ({ commit }, { id, deviceTypeId, isTotalStationSCR }) =>
			commit("updateDeviceTypeId", { id, deviceTypeId, isTotalStationSCR }),
		updateClients: ({ commit }, { id, clients }) =>
			commit("updateClients", { id, clients }),

		updatecredentialTypesList: ({ commit }, { id, credentialTypesList }) =>
			commit("updatecredentialTypesList", { id, credentialTypesList }),
		updateIntersections: ({ commit }, { id, intersections }) =>
			commit("updateIntersections", { id, intersections }),
		updateIpAddressTypes: ({ commit }, { id, ipAddressTypes }) =>
			commit("updateIpAddressTypes", { id, ipAddressTypes }),
		updateLocationTypes: ({ commit }, { id, locationTypes }) =>
			commit("updateLocationTypes", { id, locationTypes }),
		updateMacAddressTypes: ({ commit }, { id, macAddressTypes }) =>
			commit("updateMacAddressTypes", { id, macAddressTypes }),
		updateModels: ({ commit }, { id, models }) =>
			commit("updateModels", { id, models }),
		updatePrivilegeTypes: ({ commit }, { id, privilegeTypes }) =>
			commit("updatePrivilegeTypes", { id, privilegeTypes }),
		updateAuthTypes: ({ commit }, { id, authTypes }) =>
			commit("updateAuthTypes", { id, authTypes }),
		updateTenants: ({ commit }, { id, tenants }) =>
			commit("updateTenants", { id, tenants }),
		updateDeviceTenants: ({ commit }, { id, devicetenants }) =>
			commit("updateDeviceTenants", { id, devicetenants }),
		updateTestLabs: ({ commit }, { id, testLabs }) => {
			// console.log("DEBUG(updateTestLab):: testLabs: ", {id, testLabs);
			commit("updateTestLabs", { id, testLabs });
		},
		updateNetwork: ({ commit }, { id, network }) => {
			// console.log("DEBUG(updateNetwork):: network: ", {id, network);
			commit("updateNetwork", { id, network });
		},
		updateVUs: ({ commit }, { id, VUs }) => {
			// console.log("DEBUG(updateVUs):: VUs: ", {id, VUs);
			commit("updateVUs", { id, VUs });
		},
		addError: ({ commit }, { id, prop, error }) =>
			commit("addError", { id, prop, error }),
		updateViewModel: ({ commit }, { id, viewModel }) => {
			commit("updateViewModel", { id, viewModel });
		},
		updateProjectNumber: ({ commit }, { id, projectNumber }) =>
			commit("updateProjectNumber", { id, projectNumber }),
		updateSaveInfo: ({ commit }, { id, saveInfo }) =>
			commit("updateSaveInfo", { id, saveInfo }),
		updateRequestDate: ({ commit }, { id, requestDate }) =>
			commit("updateRequestDate", { id, requestDate }),
		updateDeviceRoles: ({ commit }, { id }) =>
			commit("updateDeviceRoles", { id }),
		updateSCRViewDetails: (
			{ commit },
			{ id, isReadOnly, canEditSCR, isTSReadOnly, hasTestViewRole, hasTestRole }
		) => {
			commit("updateSCRViewDetails", {
				id,
				isReadOnly,
				canEditSCR,
				isTSReadOnly,
				hasTestViewRole,
				hasTestRole
			});
		},
		updateInfrastructureOwnerId: ({ commit }, { id, infrastructureOwnerId }) =>
			commit("updateInfrastructureOwnerId", { id, infrastructureOwnerId }),
		updateInfrastructureOperatorId: (
			{ commit },
			{ id, infrastructureOperatorId }
		) =>
			commit("updateInfrastructureOperatorId", {
				id,
				infrastructureOperatorId
			}),
		updateDeviceName: ({ commit }, { id, deviceName }) =>
			commit("updateDeviceName", { id, deviceName }),
		updateAreaDescription: ({ commit }, { id, areaDescription }) =>
			commit("updateAreaDescription", { id, areaDescription }),
		updateLocationTypeId: ({ commit }, { id, locationTypeId }) =>
			commit("updateLocationTypeId", { id, locationTypeId }),
		updateLatitude: ({ commit }, { id, latitude }) =>
			commit("updateLatitude", { id, latitude }),
		updateLongitude: ({ commit }, { id, longitude }) =>
			commit("updateLongitude", { id, longitude }),
		updateElevation: ({ commit }, { id, elevation }) =>
			commit("updateElevation", { id, elevation }),
		updateAdditionalDetails: ({ commit }, { id, additionalDetails }) =>
			commit("updateAdditionalDetails", { id, additionalDetails }),
		updateIpAddressToNull: ({ commit }, { id, ipAddresses }) =>
			commit("updateIpAddressToNull", { id, ipAddresses }),

		updateDeviceScrId: ({ commit }, { id, deviceScrId }) => {
			commit("updateDeviceScrId", { id, deviceScrId });
		},
		// updateIsDraft: ({ commit }, { id , isDraft}) => commit("updateIsDraft", {id, isDraft}),
		updateTenantId: ({ commit }, { id, tenantId }) =>
			commit("updateTenantId", { id, tenantId }),
		updateClientNetworkId: ({ commit }, { id, clientnetworkId }) =>
			commit("updateClientNetworkId", { id, clientnetworkId }),
		updateManufacturerId: ({ commit }, { id, manufacturerId }) =>
			commit("updateManufacturerId", { id, manufacturerId }),
		updateModelId: ({ commit }, { id, modelId }) =>
			commit("updateModelId", { id, modelId }),
		updateSerialNumber: ({ commit }, { id, serialNumber }) =>
			commit("updateSerialNumber", { id, serialNumber }),
		updateFirmwareVersion: ({ commit }, { id, firmwareVersion }) =>
			commit("updateFirmwareVersion", { id, firmwareVersion }),
		addIpAddress: ({ commit }, { id, ipAddress }) =>
			commit("addIpAddress", { id, ipAddress }),
		removeIpAddress: ({ commit }, { id, index }) =>
			commit("removeIpAddress", { id, index }),
		addMacAddress: ({ commit }, { id, macAddress }) =>
			commit("addMacAddress", { id, macAddress }),
		removeMacAddress: ({ commit }, { id, index }) =>
			commit("removeMacAddress", { id, index }),
		addCredential: ({ commit }, { id, credential }) =>
			commit("addCredential", { id, credential }),
		removeCredential: ({ commit }, { id, index }) =>
			commit("removeCredential", { id, index }),
		updateCredential: ({ commit }, { id, credential, index }) =>
			commit("updateCredential", { id, credential, index }),
		updateTitle: ({ commit }, { id, title }) => {
			commit("updateTitle", { id, title });
		},
		updateScrModify: ({ commit }, { id, scrModify }) =>
			commit("updateScrModify", { id, scrModify }),
		updateScrStatusId: ({ commit }, { id, scrStatusId }) =>
			commit("updateScrStatusId", { id, scrStatusId }),
		updateMixonHillApproved: ({ commit }, { id, mixonHillApproved }) =>
			commit("updateMixonHillApproved", { id, mixonHillApproved }),
		updateClientApproved: ({ commit }, { id, clientApproved }) =>
			commit("updateClientApproved", { id, clientApproved }),
		updatePeople: ({ commit }, { id, people }) =>
			commit("updatePeople", { id, people }),
		updateInstallationSupportPersonId: (
			{ commit },
			{ id, installationSupportPersonId }
		) =>
			commit("updateInstallationSupportPersonId", {
				id,
				installationSupportPersonId
			}),
		updateInstallationSupportFirstName: (
			{ commit },
			{ id, installationSupportFirstName }
		) =>
			commit("updateInstallationSupportFirstName", {
				id,
				installationSupportFirstName
			}),
		updateInstallationSupportLastName: (
			{ commit },
			{ id, installationSupportLastName }
		) =>
			commit("updateInstallationSupportLastName", {
				id,
				installationSupportLastName
			}),
		updateInstallationSupportPhone: (
			{ commit },
			{ id, installationSupportPhone }
		) =>
			commit("updateInstallationSupportPhone", {
				id,
				installationSupportPhone
			}),
		updateInstallationSupportEmail: (
			{ commit },
			{ id, installationSupportEmail }
		) =>
			commit("updateInstallationSupportEmail", {
				id,
				installationSupportEmail
			}),
		updateMaintenanceSupportPersonId: (
			{ commit },
			{ id, maintenanceSupportPersonId }
		) =>
			commit("updateMaintenanceSupportPersonId", {
				id,
				maintenanceSupportPersonId
			}),
		updateMaintenanceSupportFirstName: (
			{ commit },
			{ id, maintenanceSupportFirstName }
		) =>
			commit("updateMaintenanceSupportFirstName", {
				id,
				maintenanceSupportFirstName
			}),
		updateMaintenanceSupportLastName: (
			{ commit },
			{ id, maintenanceSupportLastName }
		) =>
			commit("updateMaintenanceSupportLastName", {
				id,
				maintenanceSupportLastName
			}),
		updateMaintenanceSupportPhone: (
			{ commit },
			{ id, maintenanceSupportPhone }
		) =>
			commit("updateMaintenanceSupportPhone", { id, maintenanceSupportPhone }),
		updateMaintenanceSupportEmail: (
			{ commit },
			{ id, maintenanceSupportEmail }
		) =>
			commit("updateMaintenanceSupportEmail", { id, maintenanceSupportEmail }),
		updateAppTypes: ({ commit }, { id, appTypes }) =>
			commit("updateAppTypes", { id, appTypes }),
		updateApproachDetails: ({ commit }, { id, approachDetails }) =>
			commit("updateApproachDetails", { id, approachDetails }),
		addApproachDetails: ({ commit }, { id, approachDetails }) =>
			commit("addApproachDetails", { id, approachDetails }),
		removeApproachDetails: ({ commit }, { id, laneid }) =>
			commit("removeApproachDetails", { id, laneid }),
		updateApplications: ({ commit }, { id, application }) =>
			commit("updateApplications", { id, application }),
		clearErrors: ({ commit }, id) => commit("clearErrors", { id }),
		addApplication: ({ commit }, { id, application }) =>
			commit("addApplication", { id, application }),
		removeApplication: ({ commit }, { id, appType }) =>
			commit("removeApplication", { id, appType }),
		updateIntersectionId: ({ commit }, { id, intersectionId }) =>
			commit("updateIntersectionId", { id, intersectionId }),
		updateMovements: ({ commit }, { id, movements }) =>
			commit("updateMovements", { id, movements }),
		updateTotalStations: ({ commit }, { id, totalStations }) =>
			commit("updateTotalStations", { id, totalStations }),
		updateTotalStationName: ({ commit }, { id, totalStationName }) =>
			commit("updateTotalStationName", { id, totalStationName }),
		updateIntersectionMovementPhases: (
			{ commit },
			{ id, intersectionMovementPhases }
		) =>
			commit("updateIntersectionMovementPhases", {
				id,
				intersectionMovementPhases
			}),
		updateIntersectionMovementPhaseNumber: (
			{ commit },
			{ id, index, phaseNumber }
		) =>
			commit("updateIntersectionMovementPhaseNumber", {
				id,
				index,
				phaseNumber
			}),
		updateRejectReason: ({ commit }, { id, rejectReason }) => {
			return commit("updateRejectReason", { id, rejectReason });
		},
		updateRelationship: ({ commit }, { id, relationship }) =>
			commit("updateRelationship", { id, relationship }),
		updateHttpFlag: ({ commit }, { id, HttpFlag }) =>
			commit("updateHttpFlag", { id, HttpFlag }),
		updateRegionDistrictList: ({ commit }, { id, RegionDistrictList }) => {
			commit("updateRegionDistrictList", { id, RegionDistrictList });
		},
		updateRegionDistrict: ({ commit }, { id, RegionDistrict }) =>
			commit("updateRegionDistrict", { id, RegionDistrict }),

		updatePortTypeLists: ({ commit }, { id, PortTypeLists }) => {
			commit("updatePortTypeLists", { id, PortTypeLists });
		},
		updatePortTypes: ({ commit }, { id, PortTypes }) =>
			commit("updatePortTypes", { id, PortTypes }),
		updateHighway: ({ commit }, { id, Highway }) =>
			commit("updateHighway", { id, Highway }),
		updateMilePost: ({ commit }, { id, MilePost }) =>
			commit("updateMilePost", { id, MilePost }),
		updateSiteAddress: ({ commit }, { id, SiteAddress }) =>
			commit("updateSiteAddress", { id, SiteAddress }),
		updateDirection: ({ commit }, { id, Direction }) =>
			commit("updateDirection", { id, Direction }),
		updateDrivingAccess: ({ commit }, { id, DrivingAccess }) =>
			commit("updateDrivingAccess", { id, DrivingAccess }),
		updateHttpFlagValue: ({ commit }, { id, HttpFlagValue }) =>
			commit("updateHttpFlagValue", { id, HttpFlagValue }),
		updateSensorDataRequest: ({ commit }, { id, SensorDataRequest }) => {
			commit("updateSensorDataRequest", { id, SensorDataRequest });
		},
		updateStationCategoryValue: ({ commit }, { id, StationCategoryValue }) =>
			commit("updateStationCategoryValue", { id, StationCategoryValue }),
		updateStationTypeValue: ({ commit }, { id, StationTypeValue }) => {
			commit("updateStationTypeValue", { id, StationTypeValue });
		},
		updatehttpEnabledChkBx: ({ commit }, { id, httpEnabledChkBx }) =>
			commit("updatehttpEnabledChkBx", { id, httpEnabledChkBx }),
		updateStationCategory: ({ commit }, { id, StationCategory }) =>
			commit("updateStationCategory", { id, StationCategory }),
		updateStationTypes: ({ commit }, { id, StationTypes }) =>
			commit("updateStationTypes", { id, StationTypes }),
		updateESSInterfaceList: ({ commit }, { id, ESSInterfaceList }) =>
			commit("updateESSInterfaceList", { id, ESSInterfaceList }),
		updateNetworkList: ({ commit }, { id, NetworkList }) =>
			commit("updateNetworkList", { id, NetworkList }),
		updateTestMode: ({ commit }, { id, inTestMode }) =>
			commit("updateTestMode", { id, inTestMode }),
		updateTestLabId: ({ commit }, { id, testLabId }) =>
			commit("updateTestLabId", { id, testLabId }),
		updateNetworkId: ({ commit }, { id, networkId }) =>
			commit("updateNetworkId", { id, networkId }),
		updateTestIP: ({ commit }, { id, testIP }) =>
			commit("updateTestIP", { id, testIP }),
		updateLabTests: ({ commit }, { id, labTests }) =>
			commit("updateLabTests", { id, labTests }),
		updateLabTestId: ({ commit }, { id, labTestId }) =>
			commit("updateLabTestId", { id, labTestId }),
		updateTestCompletion: ({ commit }, { id, testCompletion }) =>
			commit("updateTestCompletion", { id, testCompletion }),
		updateTestStatus: ({ commit }, { id, testStatus }) =>
			commit("updateTestStatus", { id, testStatus }),
		updateTestResults: ({ commit }, { id, testResults }) =>
			commit("updateTestResults", { id, testResults }),
		updateVuId: ({ commit }, { id, vuId }) => commit("updateVuId", { id, vuId })
	}
};
